import { Page } from '../../../core/entities/page/page';
import { gql } from 'apollo-angular';
import { Order } from 'src/app/order-module/shared/entities/order/order';
import { Contact } from 'src/app/rent-module/shared/entities/contact/contact';
import { Resource } from 'src/app/rent-module/shared/entities/resource/resource';
import { Task } from 'src/app/rent-module/shared/entities/task/task';

// Issue interface - da Issue nicht über nx-core-module exportiert wird
export interface Issue {
  id: string;
  title: string;
  number: string;
  issueType: {
    code: string;
    name: string;
    prefix: string;
    icon: string;
    color: string;
  };
  issueStatus: {
    code: string;
    label: string;
    color: string;
  };
}


export const SEARCH_QUERY = gql`
query searchQuery($number: Int, $size: Int, $sortPropertyOrder: String, $sortPropertyResource: String, $sortPropertyContact: String, $sortPropertyIssue: String, $sortPropertyTask: String, $sortDirection: String,  $search: String)
{
  orders: getOrdersPaged(
    filter: {
      sortRequest: { sortProperties: [$sortPropertyOrder], sortDirection: $sortDirection },
      pagination: { number: $number, size: $size,  sortProperty: $sortPropertyOrder, sortDirection: $sortDirection},
      number: $search,
    }

    ) {
      totalPages
      totalElements
      number
      size
      content{
          id
          type
          number
          customer {
            type
            companyName
            firstName
            lastName
          }
      }
  }
  resources: getResourcesPaged(
    filter: {
      sortRequest: { sortProperties: [$sortPropertyResource], sortDirection: $sortDirection },
      pagination: { number: $number, size: $size,  sortProperty: $sortPropertyResource, sortDirection: $sortDirection},
      text: $search
    }
    ) {
      totalPages
      totalElements
      number
      size
      content{
          id
	        externalId
	        name
          number
      }
  }
  customers: getContactPaged(
    filter: {
      sortRequest: { sortProperties: [$sortPropertyContact], sortDirection: $sortDirection },
      pagination: { number: $number, size: $size,  sortProperty: $sortPropertyContact, sortDirection: $sortDirection},
      name: $search
    }

    ) {
      totalPages
      totalElements
      size
      content{
          id
          type
          companyName
          firstName
          lastName
          number
      }
  }
  issues: getIssuesPaged(
    filter: {
      sortRequest: { sortProperties: [$sortPropertyIssue], sortDirection: $sortDirection },
      pagination: { number: $number, size: $size,  sortProperty: $sortPropertyIssue, sortDirection: $sortDirection},
      text: $search
    }
    ) {
      totalPages
      totalElements
      number
      size
      content{
          id
          title
          number
          issueType {
            code
            name
            prefix
            icon
            color
          }
          issueStatus {
            code
            label
            color
          }
      }
  }
  tasks: getTasksPaged(
    taskFilter: {
      sortRequest: { sortProperties: [$sortPropertyTask], sortDirection: $sortDirection },
      pagination: { number: $number, size: $size,  sortProperty: $sortPropertyTask, sortDirection: $sortDirection},
      text: $search
    }
    ) {
      totalPages
      totalElements
      number
      size
      content{
          id
          title
          type
          number
      }
  }
}
`;

export interface SearchQueryResponse {
  orders: Page<Order>;
  resources: Page<Resource>;
  customers: Page<Contact>;
  issues: Page<Issue>;
  tasks: Page<Task>;
}
